import Vue from 'vue'

const requireComponent = require.context('../../lib/components', false, /[A-Z]\w+\.(vue|js)$/)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const name = fileName.split('/').pop().replace(/\.\w+$/, '')
  Vue.component(name, componentConfig.default || componentConfig)
})
